import { __assign, __rest } from "tslib";
import React, { useEffect, forwardRef, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
export var Textarea = forwardRef(function (_a, ref) {
    var value = _a.value, _b = _a.heightAutoResize, heightAutoResize = _b === void 0 ? false : _b, _c = _a.invalid, invalid = _c === void 0 ? false : _c, className = _a.className, restProps = __rest(_a, ["value", "heightAutoResize", "invalid", "className"]);
    var internalRef = useRef(null);
    useEffect(function () {
        var textareaRef;
        if (ref) {
            textareaRef = ref instanceof Function ? ref : ref.current;
        }
        else {
            textareaRef = internalRef.current;
        }
        if (heightAutoResize && textareaRef) {
            textareaRef.style.height = '0px';
            var scrollHeight = textareaRef.scrollHeight;
            textareaRef.style.height = "".concat(scrollHeight, "px");
            textareaRef.style.overflow = 'hidden';
        }
    }, [heightAutoResize, ref, value]);
    return (React.createElement("textarea", __assign({}, restProps, { className: twMerge("border border-alto rounded-default text-mirage w-full flex items-center h-[3rem] min-h-[3rem] pt-[0.625rem] px-4\n                          placeholder:text-dove\n                          focus:outline-none focus:border focus:border-cerulean-default \n                          invalid:outline-none invalid:border invalid:border-well-read\n                          disabled:bg-concrete disabled:pointer-events-none", invalid && 'outline-none border border-well-read', className), value: value, ref: ref || internalRef })));
});
export default Textarea;
